var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "m-grid m-grid--hor m-grid--root m-page" }, [
    _c(
      "div",
      {
        staticClass:
          "m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 m-login--singin",
        attrs: { id: "m_login" }
      },
      [
        _c("router-view"),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "m-grid__item m-grid__item--fluid m-grid m-grid--center m-grid--hor m-grid__item--order-tablet-and-mobile-1 m-login__content"
          },
          [
            _c("div", { staticClass: "m-grid__item m-grid__item--middle" }, [
              _c("h3", { staticClass: "m-login__welcome" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("capitalize")("welcome_message")) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "m-login__msg" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("capitalize")("superaccess_text")) +
                    "\n        "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("capitalize")("portal local")) +
                    "\n        "
                ),
                _c("br"),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("capitalize")("test_version_text")) +
                    "\n        "
                )
              ])
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1de04f06", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1de04f06","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/layout/login/Login.vue
// module id = 791
// module chunks = 0 54 184